exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".path-editor__label{font-weight:700}.path-editor{position:relative;margin-bottom:20px}.path-editor__path{line-height:20px;min-height:20px;margin-right:96px;word-wrap:break-word}.path-editor__path-container{position:relative;margin-top:8px}.path-editor__browse{position:absolute;top:-2px;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/path-editor/path-editor.scss
// module id = 597
// module chunks = 0